import { render, staticRenderFns } from "./SubdomainNodeProperties.vue?vue&type=template&id=11370c21&scoped=true"
import script from "./SubdomainNodeProperties.vue?vue&type=script&lang=js"
export * from "./SubdomainNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./SubdomainNodeProperties.vue?vue&type=style&index=0&id=11370c21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11370c21",
  null
  
)

export default component.exports